// @ts-nocheck
import React, { Component } from 'react';
import { observer, inject } from "../../../stores/mobx-compat";

import Card, { CardHead } from '../../ui/Card';
import Button from '../../ui/Button';
import Input from '../../ui/Input';
import FormGroup from '../../ui/FormGroup';
import Tooltip from '../../ui/Tooltip';
import { CheckCircleIcon, InfoIcon } from '../../ui/icons';
import CardInput from './CardInput';
import CapturePlans from './CapturePlans';

class PaymentSetup extends Component {
  render() {
    const {
      availablePlans, selectedPlan, promoValue, promoCode, loading,
      appliedPromoCode, email, total, inputHandler,
      checkPayment, verifyPromoCode,
    } = this.props.store.payments;

    return (
      <>
        <CapturePlans />

        <div className="mt-6 grid gap-5" style={{ gridTemplateColumns: this.props.store.ui.mobile ? '1fr' : '1fr 1fr' }}>
          <Card padded>
            <CardHead title="Payment details" />
            <FormGroup label="Billing email">
              <Input
                name="email"
                value={email || ''}
                onChange={(e) => inputHandler(null, { name: 'email', value: e.target.value })}
              />
            </FormGroup>
            <FormGroup label="Card">
              <CardInput />
            </FormGroup>
            <FormGroup label="Promo code">
              <div className="flex gap-2">
                <Input
                  className="flex-1"
                  name="promoCode"
                  value={promoCode || ''}
                  onChange={(e) => inputHandler(null, { name: 'promoCode', value: e.target.value })}
                />
                <Button onClick={verifyPromoCode}>Apply</Button>
              </div>
            </FormGroup>
          </Card>

          <Card padded>
            <CardHead title="Order summary" />
            <div className="flex flex-col gap-3 text-[13px]">
              {Object.keys(selectedPlan).map((plan) => {
                const matched = availablePlans.find((p) => p.id === selectedPlan[plan]);
                if (!matched) return null;
                let tooltip = null;
                if (plan === 'captureMetered') {
                  tooltip = 'Calculated based on captures, billed at end of period.';
                } else if (plan === 'recoverMetered') {
                  tooltip = 'Calculated by emails sent ($99 per 10,000).';
                }
                return (
                  <div key={plan} className="flex items-center justify-between gap-2">
                    <span className="inline-flex items-center gap-1.5">
                      {matched.nickname}
                      {tooltip && (
                        <Tooltip content={tooltip}>
                          <span className="text-mov-ink-mute"><InfoIcon size={12} /></span>
                        </Tooltip>
                      )}
                    </span>
                    <span className="mov-mono">${(matched.amount / 100) || 0} USD</span>
                  </div>
                );
              })}
            </div>

            <div className="mt-4 pt-4" style={{ borderTop: '1px solid var(--mov-line)' }}>
              {Object.keys(appliedPromoCode).length > 0 && (
                <div className="flex items-center justify-between text-[13px] mb-2">
                  <span>{appliedPromoCode.message}</span>
                  <span className="mov-mono text-mov-accent-ink">-{promoValue} USD</span>
                </div>
              )}
              <div className="flex items-center justify-between">
                <span className="mov-mono text-[11px] uppercase tracking-wider text-mov-ink-mute">Payment today</span>
                <span className="mov-display" style={{ fontSize: 22 }}>${total} USD</span>
              </div>
            </div>

            <div className="mt-4 flex justify-end">
              <Button
                variant="primary"
                icon={CheckCircleIcon}
                onClick={checkPayment}
                loading={loading}
                disabled={loading}
              >
                Confirm payment
              </Button>
            </div>
          </Card>
        </div>
      </>
    );
  }
}

export default inject('store')(observer(PaymentSetup));
